const content: { [key: string]: string } = {
  tracking: "On Track",
  notTracking: "Not Tracking",
  achieved: "Achieved",
  qualified: "Qualified",
  onHold: "On Hold",
  notEligible: "Not Eligible",
  denied: "Denied",
  disqualified: "Disqualified",
};

export default content;
